<template>
  <div
    class="rounded-t-extra-large sticky top-0 z-20 flex flex-col overflow-hidden transition-colors"
    :class="[
      hasScrolled && 'bg-surface-container-highest shadow-sm',
      !hasScrolled && 'bg-surface-container-high',
    ]"
  >
    <div class="flex h-16 w-full flex-row items-center justify-between gap-y-2 pr-4 pl-2">
      <IconButton icon="close" class="mr-2" @click="$emit('close')" />
      <slot />
      <div class="flex grow flex-row items-center justify-end gap-2">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import IconButton from '../button/icon-button/BaseIconButton.vue'

  interface Props {
    hasScrolled: boolean
  }

  defineEmits(['close'])
  defineProps<Props>()
</script>
